import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FastracDxGridWrapperComponent, FastracScreenBaseComponent } from '@bds/fastrac';
import { FastracColsService } from '@bds/services';
import { CommunicationService } from '@bds/core';
import { CarIdTransformService } from '@bds/helpers';
import { bdsGridModeType } from '@bds/components';
import { RailtracReportsService } from '../../railtrac-reports.service';
import { PageService } from '@bds/core';
import { ReportConstants } from '../../models/report-parameters.model';
import DataSource from 'devextreme/data/data_source';

@Component({
    selector: 'lib-rt-day-in-to-origin-report',
    templateUrl: './rt-day-in-to-origin-report.component.html',
    styleUrls: ['./rt-day-in-to-origin-report.component.css'],
})
export class RtDayInToOriginReportComponent
    extends FastracScreenBaseComponent
    implements OnInit, OnDestroy, AfterViewInit
{
    public gridId = 125;
    public gridMode: bdsGridModeType = 'single';
    public apiCall: string = ReportConstants.ReportDataApiCall;
    public pageHeader: string = 'Days In to Origin Report';
    public gridSource: any;
    public selectedRowKeys: Array<number> = [];

    private summaryTotalItems = [
        { column: 'return_city', summaryType: 'count', displayFormat: 'Grand Total' },
        { column: 'd1', summaryType: 'sum', displayFormat: '{0}' },
        { column: 'd2', summaryType: 'sum', displayFormat: '{0}' },
        { column: 'd3', summaryType: 'sum', displayFormat: '{0}' },
        { column: 'd4', summaryType: 'sum', displayFormat: '{0}' },
        { column: 'd5', summaryType: 'sum', displayFormat: '{0}' },
        { column: 'd6_10', summaryType: 'sum', displayFormat: '{0}' },
        { column: 'd10_plus', summaryType: 'sum', displayFormat: '{0}' },
        { column: 'eta_na', summaryType: 'sum', displayFormat: '{0}' },
        { column: 'grand_total', summaryType: 'sum', displayFormat: '{0}' },
    ];

    @ViewChild(FastracDxGridWrapperComponent) wrapper: FastracDxGridWrapperComponent;

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public gridColumnService: FastracColsService,
        public communicationService: CommunicationService,
        public carIdTransformService: CarIdTransformService,
        public reportService: RailtracReportsService,
        public pageService: PageService,
    ) {
        super(router, route, gridColumnService, communicationService, carIdTransformService);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngOnInit() {
        super.ngOnInit();
        this.pageService.setHeader(this.pageHeader);

        this.gridSource = new DataSource(
            this.reportService.CreateAspNetDatastore(this.apiCall, this.gridId.toString()),
        );
    }

    ngAfterViewInit() {
        setTimeout(() => {
            const instance = this.wrapper?.grid?.instance;
            if (instance) {
                instance.option('summary', { totalItems: this.summaryTotalItems });
            }
        }, 0);
    }
}
